import { render, staticRenderFns } from "./GameRange.vue?vue&type=template&id=4780047b&scoped=true&"
import script from "./GameRange.vue?vue&type=script&lang=js&"
export * from "./GameRange.vue?vue&type=script&lang=js&"
import style0 from "./GameRange.vue?vue&type=style&index=0&id=4780047b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780047b",
  null
  
)

export default component.exports